import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from '../../core/core.module';
import _ from 'lodash';
import { Committee, CommitteeMember } from 'app/core/model/entity-model';

@Component({
    selector: 'app-proposal-email-dialog',
    templateUrl: './proposal-email-dialog.component.html',
    styleUrls: ['./proposal-email-dialog.component.scss'],
    standalone: false,
})
export class ProposalEmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    proposal: any;
    processing = false;
    committees: any;
    selectedCommitteeId: number;
    members: any[];
    memberMessage = 'Member list will be generated after Send';
    memberCommitteeLoaded = false;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, public auth: AuthService, private utility: UtilityService) {}

    async ngOnInit() {
        this.members = [];
        this.committees = this.uow.lookups.allCommittees;
        this.selectedCommitteeId = Committee.Committees.ExecutiveCommittee;
        await this.getCommitteeMembers();
    }

    selectionChanged(e) {
        // console.log(e);
        this.members = [];
        this.getCommitteeMembers();
    }

    async getCommitteeMembers() {
        this.appInfo.pleaseWaitShow();
        let members = [];
        if (this.selectedCommitteeId === Committee.Committees.FullCouncil) {
            members = _.uniqBy((await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[], 'personId');
        } else if (this.selectedCommitteeId === 17) {
            try {
                this.appInfo.pleaseWaitShow();
                // not doing this anymore, members will be found on the server instead
                // this.memberCommitteeLoaded = (await this.utility.getMembersCommitteeMembers()) as any;
                // members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
                this.appInfo.pleaseWaitHide();
            } catch (error) {
                this.appInfo.pleaseWaitHide();
            }
        } else {
            members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
        }
        this.members = _.sortBy(members, 'person.lastName');
        this.appInfo.pleaseWaitHide();

    }

    remove(memberId: number) {
        this.members.splice(_.findIndex(this.members, {personId: memberId}), 1)
    }

    async save(sendAsText?: boolean) {
        this.processing = true;
        this.result.next({ success: true, value: this.members, sendAsText: sendAsText, congregationalVote: this.selectedCommitteeId === 17 });
    }

    close() {
        this.processing = true;
        this.result.next(false);
    }
}
